import React from 'react'
import { matchPath } from 'react-router-dom'
export const findPathUrl = (path = '', props) => {
  const { location } = props
  const objmatchPath = matchPath(location.pathname, {
    path: `${path}`,
  })
  return objmatchPath
}
